export interface IBaseRequest {
	culture: string;
	IdSessione?: string;
	step?: number;
}

export interface IBaseResponse {
	Errors: Array<IError>;
	Result: boolean;
}

export interface IError {
	Code: number;
	Message: string;
	Arguments: string;
}

export interface IStringResponse extends IBaseResponse {
	Value: string;
}

export interface IStringRequest extends IBaseRequest {
	Value: string;
}

export interface IBooleanResponse extends IBaseResponse {
	Value: boolean;
}

export interface IBooleanRequest extends IBaseRequest {
	Value: boolean;
}

export interface INumericResponse extends IBaseResponse {
	Value: number;
}

export interface INumericRequest extends IBaseRequest {
	Value: number;
}

export interface INumericArrayRequest extends IBaseRequest {
	Values: number[];
}

export const getResponseMessage = (errorList: Array<IError>) => {
	return errorList
		.map((a: IError) => {
			return a.Message;
		})
		.join();
};
